import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import { ReactNode } from 'react';
import { Helmet as ReactHelmet } from 'react-helmet-async';

import { APP_NAME } from '@/core/constants/app';

import { Header } from '../../features/Header/Header';
// import { DevOptions } from '../DevOptions/DevOptions';
import { Error } from '../Error/Error';
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import { Footer } from '../Footer/Footer';
import { ScrollUpButton } from '../ScrollUpButton/ScrollUpButton';
import { TouchEditToggleButton } from '../TouchEditToggleButton/TouchEditToggleButton';

import { layoutStyles as sx } from './Layout.styles';
import { MainContent } from './MainContent/MainContent';

type Props = {
	title?: string;
	children: ReactNode;
	displayHeader?: boolean;
	displayLogo?: boolean;
	displaySearchBar?: boolean;
	fullHeightMainContent?: boolean;
	customSx?: SxProps<Theme>;
	id?: string;
};

export const Layout = ({
	children,
	title,
	customSx,
	fullHeightMainContent,
	id,
	displayHeader = true,
	displayLogo = true,
	displaySearchBar = true
}: Props) => {
	return (
		<ErrorBoundary fallback={<Error customSx={{ root: { pt: '10%' } }} />}>
			<Box sx={sx.root} id={id}>
				<ReactHelmet>
					<title>{title ? `${title} | ${APP_NAME}` : APP_NAME}</title>
				</ReactHelmet>

				{displayHeader && (
					<Header
						displayLogo={displayLogo}
						displaySearchBar={displaySearchBar}
					/>
				)}

				<MainContent customSx={customSx} fullHeight={fullHeightMainContent}>
					{children}
				</MainContent>

				<Footer />
				<ScrollUpButton />
				<TouchEditToggleButton />
				{/* <DevOptions /> */}
			</Box>
		</ErrorBoundary>
	);
};
